var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.65 4.17a.42.42 0 00-.3-.29.42.42 0 00-.4.11L16 6.95a.4.4 0 01-.32.13l-2.17-.2a.4.4 0 01-.38-.38l-.2-2.17a.43.43 0 01.13-.33l2.97-2.96a.44.44 0 00.1-.4.4.4 0 00-.29-.29A5.98 5.98 0 009.9 1.88a5.83 5.83 0 00-1.32 6.26.42.42 0 01-.1.44L.77 16.3a2.17 2.17 0 00-.5 2.38 2.1 2.1 0 003.38.63l7.78-7.78a.4.4 0 01.44-.09 5.83 5.83 0 006.25-1.3 6 6 0 001.54-5.97z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.71e0b38e.svg";
export { ForwardRef as ReactComponent };